import { createSlice } from '@reduxjs/toolkit'

const defaultData = {
  shopId : null,
  ownerId : null,
  isOwner : false,
  couponId : null,
  qrCode : '',
}

export const ShopSlice = createSlice({
  name: 'shop',
  initialState: defaultData,
  reducers: {
    setShop: (state, action) => {
      for (const [key, value] of Object.entries(action.payload)) {
        // console.log(`${key}: ${value}`);
        state[key] = value;
      }
    },
    resetShop: () => defaultData
  },
})

// Action creators are generated for each case reducer function
export const {
  setShop,
  resetShop
} = ShopSlice.actions

export default ShopSlice.reducer